export class ProductReq{
    varientCode: string
    fromDate?:any
    toDate?:any
    constructor(varientCode:string,fromDate?:any,toDate?:any){
        this.varientCode = varientCode
        this.fromDate = fromDate
        this.toDate = toDate
    }
}